import React, { useEffect, useState } from 'react';
import styles from './VerticalNavigation.module.scss';

export const VerticalNavigation = ({ activeStep, pageList, onChange }) => {
  const [sectionName, setSectionName] = useState('how');

  const setSection = (newSection) => {
    const currentPage = pageList.find((item) => item.name === newSection);

    if (currentPage) {
      onChange(currentPage.index);
      setSectionName(currentPage.name);
    }
  };

  useEffect(() => {
    const currentPage = pageList.find((item) => item.index === activeStep);

    if (currentPage) {
      setSectionName(currentPage.name);
    }
  }, [activeStep]);

  return (
    <div className={styles.navigationWrapper}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('about') ? '' : undefined,
          }}
          onClick={() => setSection('about')}
        >
          <div className={`${styles.textRight} ${sectionName.includes('about') ? styles.big : ''}`}>
            About
          </div>
          <div className={styles.numberRight}>{sectionName.includes('about') ? '1' : ''}</div>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('what_is') ? '' : undefined,
          }}
          onClick={() => setSection('what_is')}
        >
          <div
            className={`${styles.textRight} ${sectionName.includes('what_is') ? styles.big : ''}`}
          >
            What is
          </div>
          <div className={styles.numberRight}>{sectionName.includes('what_is') ? '2' : ''}</div>
        </div>
        {sectionName.includes('what_is') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'what_is_1' ? '#757575' : undefined,
            }}
            onClick={() => setSection('what_is_1')}
          />
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('who_needs') ? '' : undefined,
          }}
          onClick={() => setSection('who_needs')}
        >
          <div
            className={`${styles.textRight} ${sectionName.includes('who_needs') ? styles.big : ''}`}
          >
            Who needs
          </div>
          <div className={styles.numberRight}>{sectionName.includes('who_needs') ? '3' : ''}</div>
        </div>
        {sectionName.includes('who_needs') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'who_needs_1' ? '#757575' : undefined,
            }}
            onClick={() => setSection('who_needs_1')}
          />
        )}
        {sectionName.includes('who_needs') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'who_needs_2' ? '#757575' : undefined,
            }}
            onClick={() => setSection('who_needs_2')}
          />
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('who_created') ? '' : undefined,
          }}
          onClick={() => setSection('who_created')}
        >
          <div
            className={`${styles.textRight} ${
              sectionName.includes('who_created') ? styles.big : ''
            }`}
          >
            Who created
          </div>
          <div className={styles.numberRight}>{sectionName.includes('who_created') ? '4' : ''}</div>
        </div>
        {sectionName.includes('who_created') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'who_created_1' ? '#757575' : undefined,
            }}
            onClick={() => setSection('who_created_1')}
          />
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('why') ? '' : undefined,
          }}
          onClick={() => setSection('why')}
        >
          <div className={`${styles.textRight} ${sectionName.includes('why') ? styles.big : ''}`}>
            Why
          </div>
          <div className={styles.numberRight}>{sectionName.includes('why') ? '5' : ''}</div>
        </div>
        {sectionName.includes('why') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'why_1' ? '#757575' : undefined,
            }}
            onClick={() => setSection('why_1')}
          />
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('supports') ? '' : undefined,
          }}
          onClick={() => setSection('supports')}
        >
          <div
            className={`${styles.textRight} ${sectionName.includes('supports') ? styles.big : ''}`}
          >
            Achieve
          </div>
          <div className={styles.numberRight}>{sectionName.includes('supports') ? '6' : ''}</div>
        </div>
        {sectionName.includes('supports') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'supports_1' ? '#757575' : undefined,
            }}
            onClick={() => setSection('supports_1')}
          />
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes('gateway') ? '' : undefined,
          }}
          onClick={() => setSection('gateway')}
        >
          <div
            className={`${styles.textRight} ${sectionName.includes('gateway') ? styles.big : ''}`}
          >
            The Gateway
          </div>
          <div className={styles.numberRight}>{sectionName.includes('gateway') ? '7' : ''}</div>
        </div>
        {sectionName.includes('gateway') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'gateway_1' ? '#757575' : undefined,
            }}
            onClick={() => setSection('gateway_1')}
          />
        )}
        {sectionName.includes('gateway') && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === 'gateway_2' ? '#757575' : undefined,
            }}
            onClick={() => setSection('gateway_2')}
          />
        )}
      </div>
      {/* <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes("supports") ? "" : undefined,
          }}
          onClick={() => setSection("supports")}
        >
          <div className={styles.textRight}>Achieve</div>
          <div className={styles.numberRight}>
            {sectionName.includes("supports") ? "6" : ""}
          </div>
        </div>
        {sectionName.includes("supports") && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === "supports_1" ? "#757575" : undefined,
            }}
            onClick={() => setSection("supports_1")}
          ></div>
        )}
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          className={styles.divRight}
          style={{
            background: sectionName.includes("gateway") ? "" : undefined,
          }}
          onClick={() => setSection("gateway")}
        >
          <div className={styles.textRight}>The Gateway</div>
          <div className={styles.numberRight}>
            {sectionName.includes("gateway") ? "7" : ""}
          </div>
        </div>
        {sectionName.includes("gateway") && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === "gateway_1" ? "#757575" : undefined,
            }}
            onClick={() => setSection("gateway_1")}
          ></div>
        )}
        {sectionName.includes("gateway") && (
          <div
            className={styles.numRight}
            style={{
              background: sectionName === "gateway_2" ? "#757575" : undefined,
            }}
            onClick={() => setSection("gateway_2")}
          ></div>
        )}
      </div> */}
    </div>
  );
};
